import { isDate } from 'date-fns';
import { DateRangeInterface } from '../models/date-range/date-range.interface';
import { DateRange } from '../models/date-range/date-range.model';
import { TsRange } from '../models/ts-range/ts-range.model';
import { isRange } from './is-range.function';

export function isDateRangeInterface<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
>(
  value: DateRangeInterface<StartBoundary, EndBoundary>,
): value is DateRangeInterface<StartBoundary, EndBoundary>;
export function isDateRangeInterface<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
>(value: {
  start: PlainStartType;
  end: PlainEndType;
  inclusiveEnd: boolean;
  inclusiveStart: boolean;
}): value is DateRangeInterface<
  StartBoundary,
  EndBoundary,
  PlainType,
  PlainStartType,
  PlainEndType
>;
export function isDateRangeInterface(
  value: unknown,
): value is DateRangeInterface<'finite' | 'infinite', 'finite' | 'infinite'>;
export function isDateRangeInterface(value: unknown): value is DateRangeInterface {
  return !!(
    !(value instanceof TsRange) &&
    !(value instanceof DateRange) &&
    value &&
    isRange(value) &&
    (value.start === null ||
      (isDate(new Date(value.start)) &&
        typeof value.start === 'string' &&
        !!value.start.match(
          /^(\d{4}(?!\d{2}\b))((-?)(0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?)?$/,
        ))) &&
    (value.end === null ||
      (isDate(new Date(value.end)) &&
        typeof value.end === 'string' &&
        !!value.end.match(/^(\d{4}(?!\d{2}\b))((-?)(0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?)?$/)))
  );
}
